import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getInboxList } from '../../../store/messageInbox/actions';
import { customBrowserFormat, formatBrowserTimeZone, formatDateTimeForBrowserTimeZone, customBrowserFormatMDYT } from '../../../components/common/DateTimeFormatter';
import { GetAllLocation } from '../../../api/groupsapi';
import { useNavigate } from 'react-router-dom';
import { GetALLAppointmentStatus, editAppointmentStatus } from '../../../api/inboxapi';
import { formatPhoneNumberAsYouType } from '../../../helpers/formatterHelper';
import { showLoading, hideLoading } from '../../../store/loading-reducer';

function Inbox() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [filter, setFilter] = useState({ sort: 2, searchby: '', locationId: 0, pastAppointmnet: null, messageCreatedDate: new Date(), appointmentStatusFilter: null });
    const { inboxDetailList } = useSelector(state => state.inboxlists);
    const [locations, setLocations] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('Open');
    const [appointmentStatus, setAppointmentStatus] = useState([]);
    const [selectAppointmnetStatusIds, setSelectAppointmnetStatusIds] = useState([]);
    const [selectedAppointmentStatus, setSelectedAppointmentStatus] = useState({ id: 0, appointmentStatusId: 0, patientId: 0 });
    const [refreshDate, setRefreshDate] = useState(new Date());

    const handleSelectChange = (e) => {
        const selectedCompanyId = parseInt(e.target.value);
        setFilter({ ...filter, locationId: selectedCompanyId });
    };

    const handleSelectChangeAppointmentStatus = (e, rowIndex, id, patientId) => {
        const appointmentStatusId = e.target.value;
        // Update the corresponding element in the array
        const updatedStatusIds = [...selectAppointmnetStatusIds];
        updatedStatusIds[rowIndex] = appointmentStatusId;
        setSelectAppointmnetStatusIds(updatedStatusIds);


        const updatedAppointmentStatus = { ...selectedAppointmentStatus, appointmentStatusId: appointmentStatusId, id: id, patientId: patientId };
        setSelectedAppointmentStatus(updatedAppointmentStatus);

        // Call the function to update the appointment status

        handleEditAppointmentStatus(updatedAppointmentStatus);
    };


    useEffect(() => {
        dispatch(getInboxList(filter));
    }, [dispatch, filter, selectedStatus]);


    useEffect(() => {
        GetAllLocation().then((response) => {
            if (response.data.success) setLocations(response.data.data);
        });
    }, []);

    useEffect(() => {
        GetALLAppointmentStatus().then((response) => {
            if (response.data.success) setAppointmentStatus(response.data.data);
        });
    }, []);

    const handleStatusButtonClick = (status) => {
        // Set the selected status
        setSelectedStatus(status);
        if (status === 'Past Appointments') {
            setFilter({ ...filter, pastAppointmnet: new Date(), messageCreatedDate: null });
        }
        else if (status === 'Complete' || status === 'No Response' || status === 'Failures' || status === 'ALL') {
            setFilter({ ...filter, pastAppointmnet: null, messageCreatedDate: null, appointmentStatusFilter: status });
        }
        else {
            setFilter({ ...filter, pastAppointmnet: null, messageCreatedDate: new Date() });
        }
    };

    const handleEditAppointmentStatus = (selectedAppointmentStatus) => {
        if (selectedAppointmentStatus != undefined && selectedAppointmentStatus != null && selectedAppointmentStatus.id > 0) {
            editAppointmentStatus({ options: { data: selectedAppointmentStatus } })
                .then((response) => {
                    if (response.data.success) dispatch(getInboxList(filter));
                    else alert(response.data.message);
                });
        }
    }
    const refreshData = async () => {
        dispatch(showLoading());
        await GetAllLocation().then((response) => {
            if (response.data.success) setLocations(response.data.data);
        });
        await GetALLAppointmentStatus().then((response) => {
            if (response.data.success) setAppointmentStatus(response.data.data);
        });
        await dispatch(getInboxList(filter));
        setRefreshDate(new Date());
        dispatch(hideLoading());
    }

    return (
        <>
            <div className="admin-page-wrap inbox-page-wrap">
                <div className="pageContainer page-container-scroll">
                    <div className="admin-page-content">
                        <div className="admin-page-title-wrap">
                            <h1 className="admin-page-heading">Inbox</h1>
                            
                        </div>
                        <div className="admin-container">
                            <div className="admin-bottom-bar filter-bar justify-content-between flex-wrap">
                                <div className="admin-bottom-bar-left">
                                    <input className="admin-default-search quoteradius"
                                        type="text"
                                        placeholder="Search by Name or Phone Number"
                                        value={filter.searchby}
                                        onChange={(e) => setFilter({ ...filter, searchby: e.target.value })}
                                    />
                                </div>
                                <div>
                                    <div className="refresh-section">
                                        Last Refresh : <b>{customBrowserFormatMDYT(refreshDate)}</b>
                                        <a role="button" className="cursor-pointer refres-point" onClick={refreshData}>
                                            <span className="material-symbols-outlined refresh-icon">
                                                refresh
                                            </span>
                                            <span className="refresh-now-btn">Refresh Now</span>
                                        </a>
                                    </div>
                                    <div className="admin-bottom-bar-right quoteradius quoteradius-btn-wrapper">
                                        <button
                                            className={`admin-button ${selectedStatus === 'Open' ? 'admin-activetab-btn' : 'admin-tab-btn'}`}
                                            onClick={() => handleStatusButtonClick('Open')}
                                        >
                                            <span>Open</span>
                                        </button>
                                        <button
                                            className={`admin-button ${selectedStatus === 'No Response' ? 'admin-activetab-btn' : 'admin-tab-btn'}`}
                                            onClick={() => handleStatusButtonClick('No Response')}
                                        >
                                            <span>No Response</span>
                                        </button>
                                        <button
                                            className={`admin-button ${selectedStatus === 'Complete' ? 'admin-activetab-btn' : 'admin-tab-btn'}`}
                                            onClick={() => handleStatusButtonClick('Complete')}
                                        >
                                            <span>Complete</span>
                                        </button>
                                        <button
                                            className={`admin-button ${selectedStatus === 'Past Appointments' ? 'admin-activetab-btn' : 'admin-tab-btn'}`}
                                            onClick={() => handleStatusButtonClick('Past Appointments')}
                                        >
                                            <span>Past Appointments</span>
                                        </button>
                                        <button
                                            className={`admin-button ${selectedStatus === 'Failures' ? 'admin-activetab-btn' : 'admin-tab-btn'}`}
                                            onClick={() => handleStatusButtonClick('Failures')}
                                        >
                                            <span>Failures</span>
                                        </button>
                                        <button
                                            className={`admin-button ${selectedStatus === 'ALL' ? 'admin-activetab-btn' : 'admin-tab-btn'}`}
                                            onClick={() => handleStatusButtonClick('ALL')}
                                        >
                                            <span>All</span>
                                        </button>

                                    </div>
                                </div>
                                
                            </div>

                            <div className="pt table-scroll">
                                <table className="admin-table w-100">
                                    <thead>
                                        <tr>
                                            <th onClick={() => setFilter({ ...filter, sort: filter.sort == 0 ? 1 : 0 })} className={filter.sort == 0 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 1 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>Name</th>
                                            <th onClick={() => setFilter({ ...filter, sort: filter.sort == 2 ? 3 : 2 })} className={filter.sort == 2 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 3 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>Appt. Date & Time</th>
                                            <th className="admin-table-name-cell">
                                                <select className="admin-default-select" onChange={handleSelectChange} value={filter?.locationId} >
                                                    <option value="0">All</option>
                                                    {locations.map((option, index) => (
                                                        <option key={index} value={option?.id}>
                                                            {option?.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </th>
                                            <th onClick={() => setFilter({ ...filter, sort: filter.sort == 4 ? 5 : 4 })} className={filter.sort == 2 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 3 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>Last Message</th>
                                            <th className="admin-table-name-cell">&nbsp;</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {inboxDetailList && inboxDetailList.map((item, index) => {

                                            //const locationNames = item?.patients?.appointments?.map(appointment => appointment.location.name);

                                            return (
                                                <tr key={index}>
                                                    <td className="admin-table-name-cell">
                                                        <span className="bold inbox-item-name space-nowrap">
                                                            {item?.patients?.map((name, nameIndex) => (
                                                                <React.Fragment key={nameIndex}>
                                                                    {name?.firstName + ' ' + name?.lastName}
                                                                    {nameIndex < item?.patients.length - 1 && <br />}
                                                                </React.Fragment>
                                                            ))}
                                                            <br />
                                                            <span className="space-nowrap font-normal inbox-item-name f-weight500">{formatPhoneNumberAsYouType(item.number && item.number) || ''}</span>
                                                        </span>
                                                    </td>

                                                    <td className="admin-table-name-cell">
                                                        {item.patients.flatMap((patient) =>
                                                            patient.appointments.map((appointment) => appointment?.appointmentDateTime)
                                                        ).filter((date, index, datesArray) => datesArray.indexOf(date) === index).map((uniqueDate, index, uniqueDatesArray) => (
                                                            <React.Fragment key={index}>
                                                                {/* {customBrowserFormat(uniqueDate)}*/}
                                                                {<div>
                                                                    <div>{customBrowserFormat(uniqueDate)}</div>
                                                                    <div>@ {formatBrowserTimeZone(uniqueDate)}</div>
                                                                </div>
                                                                }
                                                                {index < uniqueDatesArray.length - 1 && <br />}
                                                            </React.Fragment>
                                                        ))}
                                                    </td>

                                                    <td className="admin-table-name-cell">
                                                        {item.patients.flatMap((patient) =>
                                                            patient.appointments.map((appointment) => appointment?.location?.name)
                                                        ).filter((location, index, locationsArray) => locationsArray.indexOf(location) === index).map((uniqueLocation, index, uniqueLocationsArray) => (
                                                            <React.Fragment key={index}>
                                                                {uniqueLocation}
                                                                {index < uniqueLocationsArray.length - 1 && ', '}
                                                            </React.Fragment>
                                                        ))}
                                                    </td>

                                                    <td className="admin-table-name-cell inbox-item-name">
                                                        <div className="admin-round-swatch-container align-start f-weight500 cursor-pointer" onClick={() => navigate('/history/' + item?.id)}>
                                                            <span className="admin-round-swatch-last-message bold">
                                                                {item.lastMessageLog?.body && (
                                                                    <>
                                                                        {item.patients[0]?.firstName?.charAt(0)}{/* First character */}
                                                                        {item.patients[0]?.lastName?.charAt(0)}{/* Last character */}
                                                                    </>
                                                                )}
                                                            </span>
                                                            <div>
                                                                <div>
                                                                    <span >                                                                        
                                                                        {item?.lastMessageLog?.body}
                                                                    </span>
                                                                </div>
                                                                <div className="date-column d-block bg-grey light-grey nowrap last-message-Time">{formatDateTimeForBrowserTimeZone(item.lastMessageLog?.createdDate)}</div>
                                                            </div>
                                                        </div>
                                                    </td>

                                                    <td className="admin-table-name-cell">
                                                        {item.patients.length === 1 ? (
                                                            <>
                                                                {item.patients[0]?.appointments.length === 1 ? (
                                                                    <select
                                                                        className="admin-default-select ml-auto"
                                                                        onChange={(e) => handleSelectChangeAppointmentStatus(e, index, item.patients[0]?.appointments[0]?.id, item.patients[0]?.id)}
                                                                        value={selectAppointmnetStatusIds[index] || (item.patients[0]?.appointments[0]?.appointmentStatusId || '0')}
                                                                    >
                                                                       
                                                                        {(selectAppointmnetStatusIds[index] === 0 || item.patients[0]?.appointments[0]?.appointmentStatusId === 0) && (
                                                                            <option value="0">Select Action</option>
                                                                        )}
                                                                        {appointmentStatus.map((option, optionIndex) => (
                                                                            <option key={optionIndex} value={option?.id}>
                                                                                {option?.name}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                ) : (
                                                                    <div className="text-right">
                                                                        <button className="admin-button view-btn ml-auto" onClick={() => navigate('/history/' + item?.id)}>
                                                                            <span>View</span>
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            </>
                                                        ) : (
                                                            <span>No action needed</span>
                                                        )}
                                                    </td>

                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Inbox;